export default __webpack_public_path__ + "media/b8b3df597bf955b0b11446ae8a776fd449182e127eb46b779a7e6acd921d79fb.svg";